export default {
  zh: {
    getNow: "立即获取",
    servers: "服务器覆盖全球",
    lighteningSpeed: "无限的流量，极致的速度",
    everyCorner: "让您连接到世界任何角落。",
    noNeedSetting: "一键操作，无需设置",
    noTerminology: "抛开复杂的网络设置，难懂的专业术语。",
    clickContact: "您只需要打开软件，按下连接！开始你的全球大冒险。",
    noBandwidthCharge: "千兆加速，无限流量",
    breakBandwidth: "突破带宽，稳定加速",
    advancedTechnique:
      "用先进的加速技术，甚至可以突破运营商的带宽限制。在我们的带宽测试中，下载速度超过了1000Mb/s，连接延迟仅有几十毫秒。而且 Plex加速器 没有流量限制！",
    download: "立即下载",
    dataEncryption: "数据加密",
    respectPrivacy: "尊重隐私，保护您的个人信息",
    encryptInfo:
      "您访问网站的流量将会被 Plex加速器 加密，任何人都无法查看您发送的信息。当你使用 Plex 加速器 连接互联网时，我们将会隐藏你的 IP 地址，任何人都无法追踪您的位置。",
    compatibility: "设备兼容，一应俱全",
    compatibilityInfo:
      "不管操作系统是 Android、iOS、Window、MacOS、Ubuntu 还是 Android TV，Plex 加速器 都拥有操作简便的客户端。VIP 可享受手机，平板，电脑跨平台使用！",
    visitglobal: "不受限制地访问全球内容",
    visitcontent1:
      "无论您身在何处，连接 Plex加速器后都能解锁全球的网站及应用程序。数以千计的服务器供您选择，保障您的匿名在线冲浪，快速访问网站，安全下载文件，观看流媒体视频。您可以畅玩有地域限制的游戏，安全而快速地访问完整的 Netflix、Hulu、BBC 等流媒体平台。",
    visitcontent2:
      "打开 Plex加速器，按下连接按钮，享受我们的闪电冲浪速度，连接世界",
    privacyprotection: "保护您的信息安全",
    privacycontent1:
      "Plex加速器 保护使用者的隐私不被泄露。当您使用 Plex加速器 连接互联网时，我们将会隐藏您的 IP 地址，任何人都无法追踪您的位置。Plex加速器不保存任何用户日志，确保您的隐私绝对安全。同时 Plex加速器还将保护您每台设备的在线隐私安全。为您的数据加密，提升安全性。",
    privacycontent2:
      "打开 Plex加速器，按下连接按钮，享受我们的闪电冲浪速度，连接世界",
    support: "支持多种设备",
    supportDes:
      "您想要自己的隐私在所有设备上都享受保护？不管您在使用 Android、iOS、Windows、macOS、Linux 还是 Android TV，Plex加速器都能提供好用而轻便的客户端，全方位为您提供优质的服务。无论您身在何处或使用什么设备，订阅一个 Plex加速器就能满足您的需求。",
    advantage1: "操作简单",
    advantage2: "享受高速网络",
    advantage3: "无日志",
    advantagecontent1: "仅需轻轻一点，即可加密您的网络，与世界相连。",
    advantagecontent2: "超快专线，告别所有的缓冲与卡顿。",
    advantagecontent3: "Plex加速器 不保存任何用户日志，确保您的隐私绝对安全。",
    globalNote: "全球超多节点",
    multipleDevices: "支持多种设备",
    advantagecontent:
      "Plex加速器 在全球拥有超多线路，支持38个国家，55个地区，数以千计的 VPN 服务器可确保您的网络连接不受影响。加载网站、下载文件、观看视频，开启 Plex加速器 即可享受超快的互联网连接。",
    multipleDevicesContent:
      "您想要自己的隐私在所有设备上都享受保护？不管您在使用 Android、iOS、Window、MacOS、Ubuntu 还是 Android TV，Plex加速器 都能提供好用而轻便的客户端，全方位为您提供优质的服务。",
    evaluate: "我们用户的评论",
    userName1: "yy dd",
    userEvaluate1: "速度快，确实快，稳定，且不怎么影响不用梯子的软件",
    userName2: "鹏哥",
    userEvaluate2: "性价比比较高，速度比较稳定。",
    userName3: "HongJie Luo",
    userEvaluate3: "不是好，是最好！",
    userName4: "王伯宇",
    userEvaluate4: "很好的体验",
    userName5: "牵牛花的方向",
    userEvaluate5:
      "这是我用过最好用的VPN了，开发者也十分耐心的给每个评论回复，连续用了几年了，希望这软件越来越好。",
    userName6: "吴锦涛",
    userEvaluate6:
      "从买了到现在一直都很快，一直都挺快的，没出现过评论说的网速慢，慢了换节点就好了，希望这个软件能越来越好，能推出更加优惠的套餐，加油(ง •̀_•́)ง！",
    userName7: "YUNQI LAI",
    userEvaluate7:
      "网速很快，看网飞毫无压力。客服的态度和回复速度也是一流。强烈推荐！希望稳重求进，更上一层。",
    specialItem: [
      {
        title: "最佳流媒体体验",
        des: "无论身在何处，都可以观看来自世界各地被封锁的网站内容。使用 Plex加速器您不必牺牲隐私或安全，就能访问您所期望的网络。在 Plex加速器的保护下，您可以放心浏览下载您喜欢的内容，不受任何干扰地播放您喜欢的电视节目和电影。",
      },
      {
        title: "极快的 VPN 速度",
        des: "Plex加速器提供专属高速服务器，在多年的服务中不断优化网络，为您带来惊人的速度，您无需再忍受缓慢的加载时间和持续的缓冲。Plex加速器不限带宽和网速，您可以畅享高速的下载与上传体验。",
      },
      {
        title: "全面安全保护",
        des: "Plex加速器使用军用级加密技术保护您的任何连接，防止您的数据被第三方获取。同时，Plex加速器会对网络流量进行加密，并隐藏您真实的 IP 地址，确保您观看流媒体视频、打游戏、下载种子文件、网购、使用网银和浏览网页的安全。",
      },
      {
        title: "全球 5000+ 节点",
        des: "Plex加速器凭借遍布 70+ 城市的 5000+ 个服务器，确保您可以快速、安全地进行在线活动。您可以随意切换服务器，没有任何限制。Plex加速器还会自动为您选择最佳的 VPN 服务器位置，这样您就可以安全地以极快的速度探索互联网及其所有内容。",
      },
      {
        title: "一键快速连接",
        des: "只需轻轻一点，即可连接快速且安全的网络。点击“智能连接”按钮，Plex加速器会智能为您匹配高速线路进行连接。您也可以任选特定的国家，向下滚动服务器列表，挑选您想连接的服务器。",
      },
      {
        title: "高级拆分隧道",
        des: "Plex加速器支持各个应用和网站设置自定义规则，这意味着您可以选择哪些应用需要 Plex加速器的保护，哪些可以直接访问互联网。因此，您在访问不同国家/地区流媒体库的同时，也不会失去对本地服务的访问权限。",
      },
    ],
    specialTitle: "Plex加速器的独特功能",
    getPlex: "获取 PlexVPN",
    globalTitle: "全球超高速服务器",
    globalDes:
      "Plex加速器在全球拥有数千个高速且安全的 VPN 服务器。不论您从何处连接，Plex加速器都可以确保在您的附近始终有一个高宽带服务器，从而让您体验到超快速的 VPN 服务。",
    swiperItem: [
      {
        name: "Mcintosh Jalen",
        content:
          "线路比较多，节点稳定且不限量不限时，非常好，它是我见到最良心的VPN。真的。是真的很高速，不骗人。很好用，支持plex",
        imgSrc: "中",
      },
      {
        name: "jessie riven Danielle",
        content:
          "非常不错的应用，线路多可以自由切换，代理模式多有多种过滤策略还可以分应用过滤，最棒的是可以一个账号多个设备，不用搞一堆的账号了。",
        imgSrc: "中",
      },
      {
        name: "Luann Alphonsine",
        content:
          "比较好的应用，连上速度很快。应用中的代理模式很多，而且还支持分应用代理，可以去自行选择需要代理的应用，感觉还挺方便的。",
        imgSrc: "中",
      },
      {
        name: "S taurninapnio birttaneyngerete",
        content:
          "这个软件超级好用啊，上youtube都不卡，连接成功率非常高，基本上每次都能连接成功，还有各种代理模式以及分应用代理功能，良心之作。",
        imgSrc: "中",
      },
      {
        name: "YUNQI LAI",
        content:
          "网速很快，看网飞毫无压力。客服的态度喝回复速度也是一流。强烈推荐！希望稳重求进，更上一层",
        imgSrc: "中",
      },
      {
        name: "吴锦涛",
        content:
          "从买了到现在一直都很快，看P站和X站，一直都挺快的，没出现过评论说的网速慢，慢了换节点就好了，希望这个软件能越来越好，能推出更加优惠的套餐，加油(ง •̀_•́)ง！",
        imgSrc: "中",
      },
      {
        name: "峰随动",
        content: "一直用续费了8年",
        imgSrc: "中",
      },
      {
        name: "Walton Benitez",
        content:
          "软件好用，服务又好，之前听同事说的还有点不太相信，用了一段时间，特意来评价，体验超级棒，节点贼多，速度很快，而且使用过程遇到问题，客服也会很耐心帮忙解决，爱了爱了！！！",
        imgSrc: "中",
      },
      {
        name: "蒋海军",
        content: "非常好用！！强力推荐！！",
        imgSrc: "中",
      },
    ],
    swiperFrom: "来自谷歌",
    compatibilityTitle: "立即获取 Plex加速器",
    compatibilityDes:
      "Plex加速器为每个主流平台和操作系统提供专属应用程序，Plex加速器提供适用于 Windows、macOS、Linux、Android、iOS 和 Android TV 的应用程序。获取 Plex加速器以确保自己在世界各地的在线安全。",
    enjoy: "新用户享受 3 天免费试用",
    vipAdvantage: "7 天退款保障",
  },

  en: {
    getNow: "Get Now",
    servers: "Superfast servers all over the world",
    lighteningSpeed:
      "Unlimited traffic and lightning speed enable you connect every corner of the world.",
    everyCorner: " ",
    noNeedSetting: "One click connection, do not need to set up",
    noTerminology: "Ignore complicated network settings and terminology ",
    clickContact:
      "Open PlexVPN, press the connect button, and enjoy our lightening surfing speed, connect to the world",
    noBandwidthCharge: "No bandwidth charges or speed limits",
    breakBandwidth: "Breakthrough bandwidth, speed stability",
    advancedTechnique:
      "With the advanced acceleration technology, users even can break through the bandwidth limit of carriers. Through our test, the download speed exceeds 1000Mb/s with connection latency of just a few tens of milliseconds. The best part is that PlexVPN doesn’t have traffic limit.",
    download: "Download",
    dataEncryption: "Data encryption",
    respectPrivacy:
      "We respect your privacy and protect your personal information.",
    encryptInfo:
      "The traffic you send to the site will be encrypted by PlexVPN and no one will be able to view the information you send. When you use PlexVPN to connect to the Internet, we will hide your IP address and no one will be able to track your location.",
    compatibility: "Compatibility",
    compatibilityInfo:
      "PlexVPN has user-friendly clients for Android, iOS, MacOS, Ubuntu and Andorid TV devices. VIP members can enjoy the cross-platform use of mobile phones, tablets and computers.",
    visitglobal: "Bypass Geo-blocking and Get Global Content",
    visitcontent1:
      "No matter where you are, you can unblock global websites and apps with PlexVPN. Thousands of VPN servers will ensure that your internet connection is not compromised. Choose the one that works best for you to surf the web anonymously, access websites, download files, and stream videos with speedy connections. You can enjoy geo-restricted games, stream Netflix, Hulu, BBC and other streaming sites securely and quickly.",
    visitcontent2:
      "Open PlexVPN, press the connect button, and enjoy our lightening surfing speed, connect to the world",
    privacyprotection: "Protect Your Private Information",
    privacycontent1:
      "PlexVPN protects users' privacy from being leaked. When you use PlexVPN, we will hide your real IP address, and no one can track your location. PlexVPN does not store any user logs, which guarantees that you can stay private from everyone. PlexVPN will also keep your online privacy secure on every device. Keep your data encrypted for extra security.",
    privacycontent2:
      "Open PlexVPN, press the connect button, and enjoy our lightening surfing speed, connect to the world",
    support: "Support a Wide Range of Devices",
    supportDes:
      "Want privacy on all devices? PlexVPN offers user-friendly clients for Android, iOS, Windows, macOS, Linux and Android TV devices. Your data is safe with PlexVPN across all apps and platforms. No matter where you are or what device you use, a single PlexVPN subscription has got you covered.",
    advantage1: "Easy to Use",
    advantage2: "Enjoy Fast Speed",
    advantage3: "No Logs",
    evaluate: "Reviews by Our Users",
    advantagecontent1:
      "All you need is a single click, and you can secure your online traffic and connect the world.",
    advantagecontent2:
      "No more buffering and lagging with our blazing fast dedicated servers.",
    advantagecontent3:
      "PlexVPN does not store any user log, which guarantees that you can stay private from everyone, even us. ",
    globalNote: "High-speed servers worldwide",
    advantagecontent:
      "PlexVPN has a huge range of servers around the world, supporting 38 countries and 55 regions. Thousands of servers ensure that your Internet performance is not slowed down. Your browsing, downloading, streaming will be lightning fast through PlexVPN’s huge network.",
    multipleDevices: "Support a Wide Range of Devices",
    multipleDevicesContent:
      "Want privacy on all devices? PlexVPN offers user-friendly clients for Android, iOS, macOS, Ubuntu and Android TV devices. Your data is safe with PlexVPN across all apps and platforms.",
    userName1: "dlwlrma",
    userEvaluate1: "Best app quick to connect and fast server",
    userName2: "okot bruno",
    userEvaluate2:
      "This app is great it doesn't bring ads and it connects very fast",
    userName3: "Garikayi Mhizha",
    userEvaluate3:
      "This is an excellent app. It has the best servers, best customer service and surely the best reasonable prices for the great service they provide.",
    userName4: "MH Kam",
    userEvaluate4: "Excellent connectivity, the best I have ever experienced.",
    userName5: "Kenneth Mugwanya",
    userEvaluate5:
      "Supper fast connection Speed VPN I liked it in the first installation. 5/5 stars. Highly recommended. Thanks developer Team.",
    userName6: "마르티네즈남자 이름",
    userEvaluate6:
      "It Auto-Connected very quickly, It had a stable connection throughout. Love it, would recommend to some.",
    userName7: "Jesse Elizondo",
    userEvaluate7:
      "The Plex VPN works consistently well and is one of my favs.",
    specialItem: [
      {
        title: "Best Streaming Experience",
        des: "No matter where you are, unblock websites to enjoy your favorite content from anywhere in the world. Use PlexVPN to get the internet you expect, without sacrificing security or privacy. With the protection of PlexVPN, you can browse and download your favorite content, stream your favorite TV shows and movies securely with no interruptions.",
      },
      {
        title: "Blazing Fast Speeds",
        des: "PlexVPN delivers dedicated high-speed servers. PlexVPN constantly optimizes its network to bring you blazing speeds. No more slow loading times and constant buffering. You can enjoy unlimited downloads and uploads with no bandwidth restrictions or speed throttling.",
      },
      {
        title: "Strong Encryption Security",
        des: "PlexVPN protects your internet connection with military-grade encryption and ensures the security of your online personal privacy. PlexVPN encrypts your online traffic and hides your real IP address, whether you’re streaming, gaming, torrenting, shopping, banking, or simply browsing.",
      },
      {
        title: "5000+ Servers Worldwide",
        des: "With 5000+ servers in 70+ cities, PlexVPN ensures that you can conduct your online activities quickly and securely. You can switch servers as often as you like, with no limits. PlexVPN also automatically selects the best VPN server location just for you, so you can securely explore the internet and all of its content at blazing-fast speed.",
      },
      {
        title: "One-Tap Quick Connect",
        des: "Connect to a fast and secure network with just one tap. Click the “Smart Connect” button and PlexVPN will intelligently match you with a high-speed server for your connection. You can also click on a particular country, scroll down the server list and pick the one you want to connect to.",
      },
      {
        title: "Advanced Split Tunneling",
        des: "PlexVPN supports setting custom rules for individual applications and sites. This means that you can choose which applications need the protection of PlexVPN and which can access the internet directly. As a result, you can access different country/region streaming libraries without losing access to your local service.",
      },
    ],
    specialTitle: "Unique Features of PlexVPN",
    getPlex: "Get PlexVPN",
    globalTitle: "Global Ultra-Fast Servers",
    globalDes:
      "PlexVPN has thousands of ultra-fast and secure VPN servers around the world. No matter where you connect from, PlexVPN ensures that there is always a high-bandwidth server nearby, so you can experience ultra-fast VPN service.",
    swiperItem: [
      {
        name: "wei Liu Mina anthony Crystal",
        content:
          "Overall, the application is fast and wonderful, and it offered a wide range of options when I was choosing a server. The speed is obviously great, it's stable, and it's reasonably priced. Thank you very much.",
        imgSrc: "y",
      },
      {
        name: "minmaw koon",
        content: "Good vpn I really like this vpn",
        imgSrc: "y",
      },
      {
        name: "Salman Cheema",
        content: "Good option for VPN. For using Netflix as well",
        imgSrc: "y",
      },
      {
        name: "Ali Samorayi",
        content: "Realy beeest and amazing vpn",
        imgSrc: "y",
      },
      {
        name: "MH Kam",
        content: "Excellent connectivity, the best I have ever experienced.",
        imgSrc: "y",
      },
      {
        name: "ashlee andre",
        content:
          "Very fast internet connection for downloading and watching online movies and news. Thank you PlexVPN. Best wishes",
        imgSrc: "y",
      },
      {
        name: "henry ashe",
        content:
          "Have been using this app for half a year. Your team did an excellent job with this app, especially for MLBB players. PlexVPN did boost my network connection.",
        imgSrc: "y",
      },
      {
        name: "Mary Nalan",
        content:
          "Good app to change your location......plexVPN is the best app make a download quick and enjoy your fast location",
        imgSrc: "y",
      },
      {
        name: "Ntege Lawrence",
        content:
          "Best vpn every body download leave phisphon thunder and others this is the best vpn i have used it for real",
        imgSrc: "y",
      },
    ],
    swiperFrom: "founder at Google",
    compatibilityTitle: "Get PlexVPN Now",
    compatibilityDes:
      "PlexVPN has dedicated apps for every major platform and operating system. PlexVPN is available for Windows, macOS, Linux, Android, iOS, and Android TV systems. Get PlexVPN to ensure your online security around the world.",
    enjoy: "Enjoy 3-Day Free Trial for New Users",
    vipAdvantage: "7-Day Money-Back Guarantee",
  },
};



// WEBPACK FOOTER //
// ./src/views/home/homeBodyPc/lang.js